import { forwardRef } from "react";
import { Input as AriaInput, InputProps } from "react-aria-components";

const Input = forwardRef<HTMLInputElement, InputProps>((props, ref) => {
  return (
    <AriaInput
      className={`h-14 w-full rounded-[100vw] border border-gray-300 px-4 outline-none placeholder:text-gray-300 ${props.className}`}
      {...props}
      ref={ref}
    />
  );
});

Input.displayName = "Input";
export default Input;
